import { Page } from '@/components/layout/page/page.tsx'
import { MessageMediaQueryProvider } from '@/modules/message/query/message-media-query-context.tsx'
import { DefaultMessageMediaProvider } from '@/modules/message/service/message-fetch-context.tsx'
import { CreateMessageButton } from '@/modules/online-mass-messages/ui/create-message-button'
import { MassMessagesTable } from '@/modules/online-mass-messages/views/mass-messages-table'

export const OnlineMassMessagesView = () => {
  return (
    <Page
      title="Online Mass Messages"
      description={
        <span className="flex items-center gap-1">
          Configure an Online Mass Message to be sent out to users who are
          online & come online during the selected time frame.
        </span>
      }
      headerOptions={
        <div className="flex gap-2">
          <CreateMessageButton className="whitespace-nowrap text-sm font-normal leading-6" />
        </div>
      }
      className="mb-6"
    >
      <DefaultMessageMediaProvider>
        <MessageMediaQueryProvider>
          <MassMessagesTable />
        </MessageMediaQueryProvider>
      </DefaultMessageMediaProvider>
    </Page>
  )
}
